/*localhost *
export const AUTH_ENDPOINT = 'http://127.0.0.1:3000/userauth/';
export const API_BASE_URL = 'http://127.0.0.1:3000';
/**/

/* production */
export const AUTH_ENDPOINT = 'https://ch-api.cloudhints.com/userauth/';
export const API_BASE_URL = 'https://ch-api.cloudhints.com';
/**/


// WEBPACK FOOTER //
// ./src/endpoints.js